import axiosInstance from "./AxiosInstance";
import config from "../config";

export const generateUploadUrl = (contentType) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;
  return fetch(
    `${config?.appUrl}${config.routes.getBusinessFileUploaderLink}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": contentType,
      },
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      throw error;
    });
};

export const SubmitFile = async (submitUrl, data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return await axiosInstance({
    url: submitUrl,
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  })
    .then((response) => {
      console.log("Response Headers:", response.headers); // Debug response headers
      return response;
    })
    .catch((error) => {
      console.log("Error Response:", error.response); // Debug error response
      throw error;
    });
};

export const uploadFile = async (data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return await axiosInstance({
    url: config.routes.uploadFile,
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};
export const uploadVoiceNoteservice = async (data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return await axiosInstance({
    url: config.routes.uploadVoiceNote,
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};
export const fetchRequiredFileList = async () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return await axiosInstance({
    url: config.routes.requiredFileList,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const fetchFilePublicUrl = async (key, fileType) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return await axiosInstance({
    url: config.routes.fileViewUrl,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      key,
    },
  });
};

export const fetchFileDelete = async (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return await axiosInstance({
    url: config.routes.fileDelete(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
